export default theme => ({
	elements: {
		padding: `${theme.spacing(3, 1, 0, 1)} !important`
	},
	tabPanel: {
		width: '100%'
	}
});
